import {
  Box,
  Typography,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  CircularProgress,
  Select,
  MenuItem,
  InputLabel,
  SelectChangeEvent,
} from '@mui/material'
import { Button, CalendarInput, Input } from 'Common/Supplyvue-ui'
import { CreatePlanSelectProps, CreatePlanTextBoxProps } from './Common.types'
import { PLAN_ACCESS_TYPE } from 'Common/Constants/Constants'
import { CreatePlanButtonGroupProps } from 'Features/CreateScenarioPlan/CreateScenarioPlan.types'
import { Edit } from '@mui/icons-material'

export const CreatePlanTextBox = ({
  setPlanValue,
  value,
  planDataKey,
  disabled,
  label,
  inputType,
}: CreatePlanTextBoxProps) => {
  return (
    <Box
      display={'flex'}
      flexDirection="row"
      marginTop={2}
      justifyContent="space-between"
    >
      <Box display="flex" alignItems="center" width="30%">
        <Typography>{label}</Typography>
      </Box>
      <Box marginLeft={3}>
        {inputType && inputType === 'number' ? (
          <Input
            sx={{ width: '300px' }}
            value={value}
            onChange={(e) => setPlanValue(planDataKey, e.target.value)}
            disabled={disabled}
            type="number"
            inputProps={{ min: 0 }}
          />
        ) : (
          <Input
            sx={{ width: '300px' }}
            value={value}
            onChange={(e) => setPlanValue(planDataKey, e.target.value)}
            disabled={disabled}
          />
        )}
      </Box>
      <Box display="flex" alignItems="center" width="10%">
        {inputType && inputType === 'number' ? 'Weeks' : ''}
      </Box>
    </Box>
  )
}

export const CreatePlanCalendar = ({
  setPlanValue,
  planDataKey,
  value,
  disabled,
  label,
}: CreatePlanTextBoxProps) => {
  return (
    <Box display="flex" flexDirection="row" justifyContent="space-between">
      <Box display="flex" alignItems="center" width="30%">
        <Typography>{label}</Typography>
      </Box>
      <Box marginLeft={3}>
        <CalendarInput
          label={label}
          sx={{ width: '300px' }}
          format="dd-MM-yyyy"
          onChange={(date) => setPlanValue(planDataKey, date)}
          value={value as Date}
          disabled={disabled}
          shouldDisableDate={(date) => date.getDay() !== 1}
        />
      </Box>
      <Box display="flex" alignItems="center" width="10%"></Box>
    </Box>
  )
}

export const CreatePlanAccess = ({
  setPlanValue,
  label,
  disabled,
  planDataKey,
  value,
}: CreatePlanTextBoxProps) => {
  return (
    <Box
      display={'flex'}
      flexDirection="row"
      marginTop={2}
      justifyContent="space-between"
    >
      <Box display="flex" alignItems="center" width="30%">
        <Typography>{label}</Typography>
      </Box>
      <Box marginLeft={3}>
        <FormControl disabled={disabled}>
          <RadioGroup
            aria-labelledby="plan-access-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={value}
            onChange={(e) => setPlanValue(planDataKey, e.target.value)}
            row
          >
            <FormControlLabel
              value={PLAN_ACCESS_TYPE.PRIVATE}
              control={<Radio />}
              label="Private"
            />
            <FormControlLabel
              value={PLAN_ACCESS_TYPE.PUBLIC}
              control={<Radio />}
              label="Public"
            />
          </RadioGroup>
        </FormControl>
      </Box>
      <Box display="flex" alignItems="center" width="10%" paddingLeft={1}></Box>
    </Box>
  )
}

export const CreatePlanButtonGroup = ({
  isEditSettings,
  handleRunPlan,
  disabled,
  isRunPlan,
  isPlanCreating,
  handleEditSettings,
}: CreatePlanButtonGroupProps) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Button
        onClick={handleRunPlan}
        sx={{
          marginLeft: '20px',
          minWidth: '105px',
        }}
        label="Create plan"
        disabled={disabled}
        variant="contained"
      >
        {isRunPlan && (
          <CircularProgress
            color="inherit"
            size={16}
            sx={{ marginRight: '8px' }}
          />
        )}
        Run plan
      </Button>
      <Box sx={{ marginRight: 5 }} />

      <Button
        onClick={handleEditSettings}
        variant="outlined"
        disabled={isPlanCreating}
        startIcon={
          isEditSettings ? (
            <CircularProgress
              size={16}
              color="inherit"
              sx={{ marginRight: '8px' }}
            />
          ) : (
            <Edit />
          )
        }
      >
        Edit Settings (Optional)
      </Button>
    </Box>
  )
}

export const CreatePlanSelect = ({
  setPlanValue,
  label,
  disabled,
  planDataKey,
  value,
  data,
  isLoading,
}: CreatePlanSelectProps) => {
  return (
    <Box
      display={'flex'}
      flexDirection="row"
      marginTop={2}
      justifyContent="space-between"
    >
      <Box display="flex" alignItems="center" width="30%">
        <Typography>{label}</Typography>
      </Box>
      <Box marginLeft={3}>
        {isLoading ? (
          <CircularProgress size={16} />
        ) : (
          <FormControl disabled={disabled}>
            <InputLabel id={`select-label-${label}`}>{label}</InputLabel>
            <Select
              fullWidth
              sx={{
                width: '300px',
              }}
              id={`select-${label}`}
              value={value as string}
              label={label}
              onChange={(event: SelectChangeEvent<string>) =>
                setPlanValue(planDataKey, event.target.value)
              }
            >
              {data.map((item) => {
                return (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl>
        )}
      </Box>
      <Box display="flex" alignItems="center" width="10%" paddingLeft={1}></Box>
    </Box>
  )
}
